module.exports = __webpack_public_path__ + "img/playVideo_c.83a8a338.svg";